// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav {
  position: sticky;
  width: 100%;
  height: 107px;
  left: 0px;
  top: 0px;
  background-color: #D9D9D9;
  padding: 10px;

  z-index: 9999;
}

.nav-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  position: absolute;
  width: 100%;
  height: 105px;
  left: 0px;
  top: 0px;
}

.nav-title {
  width: 100%;

  font-style: normal;
  font-weight: 400;
  font-size: 50px;

  color: #6b3cb9;
  font-family: 'Lemon/Milk', Arial, Helvetica, sans-serif;
}

.sub {
  width: 100%;
  height: 31px;

  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 31px;

  color: #6b3cb9;
  font-family: 'Lemon/Milk', Arial, Helvetica, sans-serif;
}


.side-button-container {
  position: absolute;
  right: 30px;
  top: 0px; /*negate parent padding*/
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

@media (max-width: 950px) {
  .nav {
    height: 79px;
  }

  .nav-title {
    font-size: 30px;
  }

  .sub {
    font-size: 16px;
  }

  .side-button-container {
    flex-direction: column;
  }
}

@media (max-width: 450px) {
  .nav {
    height: 100px;
    width: 100%;
  }
  .side-button-container {
    flex-direction: row;
    top: 51px;
    width: 100%;
    right: 0px;
  }

  .nav-button {
    height: 28px;
    width: 100px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/TopNav.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,aAAa;;EAEb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;;EAElB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,WAAW;;EAEX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;;EAEf,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,cAAc;EACd,uDAAuD;AACzD;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ,EAAE,wBAAwB;EAClC,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".nav {\n  position: sticky;\n  width: 100%;\n  height: 107px;\n  left: 0px;\n  top: 0px;\n  background-color: #D9D9D9;\n  padding: 10px;\n\n  z-index: 9999;\n}\n\n.nav-header {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n\n  position: absolute;\n  width: 100%;\n  height: 105px;\n  left: 0px;\n  top: 0px;\n}\n\n.nav-title {\n  width: 100%;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 50px;\n\n  color: #6b3cb9;\n  font-family: 'Lemon/Milk', Arial, Helvetica, sans-serif;\n}\n\n.sub {\n  width: 100%;\n  height: 31px;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 30px;\n  line-height: 31px;\n\n  color: #6b3cb9;\n  font-family: 'Lemon/Milk', Arial, Helvetica, sans-serif;\n}\n\n\n.side-button-container {\n  position: absolute;\n  right: 30px;\n  top: 0px; /*negate parent padding*/\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n@media (max-width: 950px) {\n  .nav {\n    height: 79px;\n  }\n\n  .nav-title {\n    font-size: 30px;\n  }\n\n  .sub {\n    font-size: 16px;\n  }\n\n  .side-button-container {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 450px) {\n  .nav {\n    height: 100px;\n    width: 100%;\n  }\n  .side-button-container {\n    flex-direction: row;\n    top: 51px;\n    width: 100%;\n    right: 0px;\n  }\n\n  .nav-button {\n    height: 28px;\n    width: 100px;\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
